import React, { Component } from 'react';
import { Route, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Raven from 'raven-js';
import Header from '../../components/Header';
import BottomTabs from '../../components/BottomTabs';

import Home from '../home';
import Add from '../add';
import More from '../more';
import Profile from '../profile';
import Donations from '../donations';
import SuccessfulDonation from '../successful_donation';
import Faqs from '../faqs';
import Privacy from '../privacy';
import Terms from '../terms';
import Exports from '../exports';

import api from '../../api';
import { imageURL } from '../../constants';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null
    };
  }

  componentDidMount() {
    //this._fetchBackgroundImage();
  }

  /*
  _fetchBackgroundImage = () => {
    api
      .fetchBackgroundImage()
      .then(result => {
        console.log(result);
        const image = result.field_background_image.und[0].uri.replace(
          'public://',
          imageURL
        );
        console.log(image);
        this.setState({ image });
      })
      .catch(err => {
        console.log(err);
      });
  };
  */

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  render() {
    const { image } = this.state;

    let appStyle = {};

    if (image) {
      appStyle = { backgroundImage: `url(${image})` };
    }

    return (
      <div style={appStyle}>
        <Header />

        <main style={{ display: 'flex', flex: 1, marginTop: 60 }}>
          <Route exact path="/" component={Home} />
          <Route exact path="/add" component={Add} />
          <Route exact path="/add/success" component={SuccessfulDonation} />
          <Route exact path="/profile" component={Profile} />
          <Route exact path="/profile/donations" component={Donations} />
          <Route exact path="/more" component={More} />
          <Route exact path="/faqs" component={Faqs} />
          <Route exact path="/privacy" component={Privacy} />
          <Route exact path="/terms" component={Terms} />
          <Route exact path="/exports" component={Exports} />
        </main>

        <BottomTabs />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/app/index.js